export default __webpack_public_path__ + "static/media/MACS-FO-Logo.bb7d933b.png";